import {Component, input, InputSignal} from '@angular/core';
import {TranslatePipe} from "@ngx-translate/core";
import { RestrictedIndicatorComponent } from '../restricted-indicator/restricted-indicator.component';

@Component({
  selector: 'app-object-view-section-title',
  imports: [
    TranslatePipe,
    RestrictedIndicatorComponent
  ],
  templateUrl: './object-view-section-title.component.html',
  styleUrl: './object-view-section-title.component.scss'
})
export class ObjectViewSectionTitleComponent {
  showRestrictedIndicator: InputSignal<boolean> = input(false);
  title: InputSignal<string> = input('');
}
